import { RouteRecordRaw } from 'vue-router';

const USER_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'UsersOverview',
      component: () => import('@/modules/users/pages/UsersOverview.vue'),
   },
   {
      path: '/import',
      name: 'UsersBulkImport',
      component: () => import('@/modules/users/pages/UsersBulkImport.vue'),
   },
   {
      path: ':id',
      name: 'UserDetail',
      component: () => import('@/modules/users/pages/UserDetail.vue'),
      children: [
         {
            path: 'general',
            alias: '',
            name: 'UserGeneral',
            component: () => import('@/modules/users/components/user-detail/UserGeneral.vue'),
         },
         {
            path: 'permissions',
            alias: 'permission',
            name: 'UserPermissions',
            component: () => import('@/modules/users/components/user-detail/UserPermissions.vue'),
         },
      ],
   },
];

export default USER_ROUTES;
